import React, { useState, useEffect } from "react";
import { AppLoad } from "../../../core/AppLoad";
import { AppConfig } from "../../../app-state";
// import { ListItem } from "./ListItem";
import { useParams, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { SubmitErrors } from "../../../core/SubmitErrors";
import { FormAdmin } from "./FormAdmin";
import { Spinner } from "../../../core/Spinner";
import { SubmitButton } from "../../../core/SubmitButton";
const submitErrorsDictionary = {
    fullname_required: "Jméno a příjmení je vyžadováno",
    email_required: "Email je vyžadován",
    email_used: "Pro uvedený email už existuje účet"
};
export const Form = (props) => {
    // const [wasSaved, setWasSaved] = useState(false);
    const [account, setAccount] = useState({});
    const [submitErrors, setSubmitErrors] = useState([]);
    const [loadState, setLoadState] = useState('loading'); //idle | loading | submitting | saved
    const history = useHistory();
    const { register, handleSubmit, errors, reset } = useForm();
    const { urlAccountId, urlRole } = useParams();
    const onSubmit = (data) => {
        setLoadState('submitting');
        setSubmitErrors([]);
        data.id = urlAccountId;
        data.role = urlRole;
        AppLoad(AppConfig.APIUrl + 'admin/user-management/Save', data).then((Response) => {
            if (Response.status == 'error') {
                setSubmitErrors(Response.errors);
            }
            else if (Response.status == 'ok') {
                history.push("/cs/sekce/sprava-uzivatelu/admin");
            }
            setLoadState('saved');
        });
    };
    useEffect(() => {
        if (urlAccountId == 'novy') {
            setLoadState('idle');
            reset();
        }
        else {
            setLoadState('loading');
            const data = { accountId: props.id };
            AppLoad(AppConfig.APIUrl + 'admin/user-management/Detail', data).then((Response) => {
                if (Response.status == 'ok')
                    setAccount(Response.UserData);
                setLoadState('idle');
            });
        }
    }, [urlAccountId]);
    if (loadState == 'loading')
        return React.createElement(Spinner, null);
    return (React.createElement("div", { className: "container" },
        React.createElement("form", { className: "cms-article cms-single-panel", onSubmit: handleSubmit(onSubmit) },
            React.createElement("fieldset", { disabled: loadState == 'submitting', onChange: () => setLoadState('idle') },
                React.createElement("legend", { className: "sr-only" }, "Formul\u00E1\u0159"),
                React.createElement("div", { className: "record-catalogue-form-fields-wrap" },
                    urlAccountId == 'novy' ?
                        React.createElement("h2", null, "Nov\u00FD \u00FA\u010Det administr\u00E1tora")
                        :
                            React.createElement("h2", null,
                                "Editovat #",
                                account.id || null),
                    React.createElement(SubmitErrors, { errors: submitErrors, dictionary: submitErrorsDictionary }),
                    React.createElement(FormAdmin, { account: account, register: register, errors: errors }),
                    React.createElement("div", { className: "text-right" },
                        React.createElement(SubmitButton, { label: "Ulo\u017Eit", loadState: loadState })))))));
};
